import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';

import { ForgotService } from './service/forgot.service';

declare var $: any;

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {

  msgInfo: string = '';
  isDisabled: boolean = false;
  mail: any;
  msgButton: string = 'Recuperar';
  subscriptionGet: Subscription;

  constructor(private router: Router, private forgotService: ForgotService, ) { }

  ngOnInit() {
  }

  doForgot() {

    if (!this.mail) {
      this.msgInfo = "Campo obrigatório.";
      return;
    }

    this.msgInfo = "";
    this.msgButton = "carregando....";
    this.isDisabled = true;

    this.subscriptionGet = this.forgotService.login(this.mail)
      .subscribe(succ => {
        let ret: any = succ;
        this.msgInfo = ret.messege;

        if (ret.success) {
          this.openMsg(ret.messege);
          this.router.navigate(['/login']);
        }

      }, err => {
        this.msgInfo = "Erro ao realizar login!";
        this.msgButton = "Recuperar";
        this.isDisabled = false;

      }, () => {
        this.msgButton = "Recuperar";
        this.isDisabled = false;
      });

  }

  goLogin() {
    this.router.navigate(['/login']);
  }

  openMsg(msg) {

    $.notify({
      icon: "pe-7s-info",
      message: msg
    }, {
        type: 'success',
        timer: 1500,
        placement: {
          from: 'bottom',
          align: 'right'
        }
      });
  }

  ngOnDestroy() {
    if (this.subscriptionGet)
      this.subscriptionGet.unsubscribe();
  }
}
